// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1bCRN","fileBtn":"File_fileBtn__2DTBd","closeBtn":"File_closeBtn__3ho8k","fileSelected":"File_fileSelected__2uP7S","disabled":"File_disabled__4MAHo"};